import { render } from "./PrivacyPolicyPage.vue?vue&type=template&id=6b7c79c0"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__